import { renderMarkdown } from '../utils/markdown';

interface Props {
  content: string;
  /**
   * Render headings as bold text rather than <h1>-<h4>. Use inside table cells
   * and other tight containers: this app ships no stylesheet, so a real heading
   * takes the browser default size and blows out the row.
   */
  flattenHeadings?: boolean;
}

export function Markdown({ content, flattenHeadings }: Props) {
  if (!content) return null;
  return (
    <div
      className="markdown-content"
      dangerouslySetInnerHTML={{ __html: renderMarkdown(content, { flattenHeadings }) }}
      style={{ lineHeight: 1.6 }}
    />
  );
}
